import { Location } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Interrupt, LOGIN_REALM, LOGIN_SERVICE_URL } from '@usana/ux/sso-auth';
import { SharedLoginConstants } from '../shared-login.constants';

@Injectable({
  providedIn: 'root',
})
// this class isn't part of the interrupt module on purpose
export class InterruptTransferService {
  private accessToken: string;
  private readonly accessTokenStorageKey: string = 'ssoAccessTokenForInterrupts';

  private interruptsToTransfer: Interrupt[];

  constructor(
    private readonly httpClient: HttpClient,
    private readonly router: Router,
    private readonly location: Location,
    @Inject(LOGIN_REALM) private readonly loginRealm: string,
    @Inject(LOGIN_SERVICE_URL) private readonly loginServiceUrl: string
  ) {
    const interruptInfo = this.loadInterruptInfo();
    if (interruptInfo) {
      this.accessToken = interruptInfo.token;
      this.interruptsToTransfer = interruptInfo.interrupts;
      if (this.accessToken) {
        // if we aren't currently on a before path
        if (this.location.path().indexOf(SharedLoginConstants.INTERRUPT_PATH) < 0) {
          this.router.navigate([SharedLoginConstants.INTERRUPT_PATH]);
        }
      }
    }
  }

  getAccessToken(): string {
    return this.accessToken;
  }

  handleInterrupts(accessToken: string, interrupts: Interrupt[]): void {
    this.storeInterruptInfo(accessToken, interrupts);
    this.accessToken = accessToken;
    this.interruptsToTransfer = interrupts;
    // redirect to the first one
    this.router.navigate([SharedLoginConstants.INTERRUPT_PATH, interrupts[0].url]);
  }

  oneTimeTransfer(): Interrupt[] {
    const ret = this.interruptsToTransfer;
    // we want to delete this because we can't trust this value after we start operating on it
    delete this.interruptsToTransfer;
    this.cleanupInterruptInfo();
    return ret;
  }

  cleanup(): void {
    delete this.accessToken;
    delete this.interruptsToTransfer;
    this.cleanupInterruptInfo();
  }

  private storeInterruptInfo(accessToken: string, interrupts: Interrupt[]): void {
    if (!!Storage) {
      sessionStorage.setItem(
        this.accessTokenStorageKey,
        JSON.stringify({
          token: accessToken,
          interrupts: interrupts,
        })
      );
    }
  }

  private loadInterruptInfo(): any {
    if (!!Storage) {
      return JSON.parse(sessionStorage.getItem(this.accessTokenStorageKey));
    }
    return null;
  }

  private cleanupInterruptInfo(): void {
    if (!!Storage) {
      sessionStorage.removeItem(this.accessTokenStorageKey);
    }
  }
}
